import React from 'react'
import styles from './FirstView.module.css'

const IMAGES = {
    firstViewImg: '/pages/firstview_2954.png',
}

// DEV-3419: instagram_ascはSlimFirstView(帯)に一本化されたため、差し替え用のimageSrc propは廃止。
// 現在の利用者は instagram の5エリア(kanto/kansai/nagano/nagasaki/okinawa)のみ。
// tiktok_smart_plus は同名だが別コピー(tiktok/shared/sections/FirstView)を使う。
export const FirstView = ({ dataViewLabel }) => {
    return (
        <section>
            <div className={styles.contentWrap}>
                <img src={IMAGES.firstViewImg} alt={'葵わかなさん'} data-view-label={dataViewLabel}/>
            </div>
        </section>
    )
}
